export interface AvatarLike {
  avatarUrl?: unknown;
  preferences?: unknown;
}

const normalizeUrl = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const getEffectiveAvatarUrl = (source?: AvatarLike | null): string | null => {
  if (!source) {
    return null;
  }

  const direct = normalizeUrl(source.avatarUrl);
  if (direct) {
    return direct;
  }

  if (source.preferences && typeof source.preferences === 'object') {
    const preferencesRecord = source.preferences as Record<string, unknown>;
    const fromPreferences = normalizeUrl(preferencesRecord.avatarUrl);
    if (fromPreferences) {
      return fromPreferences;
    }
  }

  return null;
};

